<div *ngIf="useDefaultViewer; else useLexViewer" style="display: flex; flex-direction: column; justify-content: center; height: 100%">
  <iframe *ngIf="url$ | async as url" [ngClass]="{'disable-mouse-events' : isContextPanelResizing}"
          [src]="url | safeResourceUrl"></iframe>
</div>
<ng-template #useLexViewer>
  <div style="display: flex; flex-direction: column; justify-content: center; height: 100%">
    <lex-pdf-viewer *ngIf="url$ | async as url" [pdfUrl]="url" [ngClass]="{'disable-mouse-events' : isContextPanelResizing}" style="overflow: hidden;"></lex-pdf-viewer>
  </div>
</ng-template>